import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { IconButtonComponent } from '@mode/capra';

@Component({
  standalone: true,
  selector: 'mode-legacy-dialog-header',
  imports: [CommonModule, IconButtonComponent],
  templateUrl: 'legacy-dialog-header.component.html',
  styleUrls: ['./legacy-dialog-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegacyDialogHeaderComponent {
  @Output() closed = new EventEmitter<void>();
}
